<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Add Training Course</h5>
      <form [formGroup]="AddNewDorehAmoozeshi" (submit)="SubmitAddNewDorehAmoozeshi()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Title</label>
            <input formControlName="Title" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">Enter the title.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Training Syllabus  </label>
            <select class="custom-select" formControlName="GroupId" >
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_SarFaslAmozeshi" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
        </div>
        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewDorehAmoozeshi.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
        <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
        <button routerLink="/DorehAmoozeshi" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

